import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const AppContext = /*#__PURE__*/React.createContext({
  mountPath: '',
  bootstrapConfig: undefined
});
export const AppContextProvider = _ref => {
  let {
    children,
    mountPath,
    bootstrapConfig
  } = _ref;
  return /*#__PURE__*/_jsx(AppContext.Provider, {
    value: {
      mountPath,
      bootstrapConfig
    },
    children: children
  });
};
const useAppContext = () => {
  return useContext(AppContext);
};
export function withMountPath(WrappedComponent) {
  return function AppContextHOC(props) {
    return /*#__PURE__*/_jsx(AppContext.Consumer, {
      children: appContext => {
        return /*#__PURE__*/_jsx(WrappedComponent, _objectSpread({
          mountPath: appContext.mountPath
        }, props));
      }
    });
  };
}
export const useMountPath = () => {
  const {
    mountPath
  } = useAppContext();
  return mountPath;
};
export const useBootstrapConfig = () => {
  const {
    bootstrapConfig
  } = useAppContext();
  return bootstrapConfig;
};
export const useEnvironment = () => {
  const {
    bootstrapConfig: {
      environment
    }
  } = useAppContext();
  return environment;
};
export const useAlgoliaConfig = () => {
  const {
    bootstrapConfig: {
      algolia
    }
  } = useAppContext();
  return algolia;
};